// Sorts rows by an accessor, with empty values last whichever way the column is sorted.
export const sortByAccessor = (rows, sort, accessor) => {
  if (!sort || !accessor) return rows;
  const dir = sort.dir === "desc" ? -1 : 1;
  return [...rows].sort((a, b) => {
    const va = accessor(a);
    const vb = accessor(b);
    if (va == null || va === "") return 1;
    if (vb == null || vb === "") return -1;
    return (typeof va === "number" ? va - vb : String(va).localeCompare(String(vb))) * dir;
  });
};

// The next sort when a header is clicked: same column flips direction, a new one starts ascending.
export const toggleSort = (sort, key) =>
  sort?.key === key ? { key, dir: sort.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" };

// Click cycle for a column header: A–Z, then Z–A, then cleared (null).
export const cycleSort = (sort, key) =>
  sort?.key !== key ? { key, dir: "asc" } : sort.dir === "asc" ? { key, dir: "desc" } : null;
